import { Input, Popover } from 'antd';
import React from 'react';
import { SketchPicker } from 'react-color';

type Props = {
  value?: any;
  onChange?: (v: any) => void;
};

export default function ColorPicker({ value, onChange }: Props) {
  const [showPicker, togglePicker] = React.useState<boolean>(false);
  return (
    <Popover
      onVisibleChange={v => togglePicker(v)}
      trigger="click"
      visible={showPicker}
      placement="bottomRight"
      content={
        <SketchPicker
          onChange={color => {
            if (onChange) {
              onChange(color.hex);
            }
          }}
          color={value}
        />
      }
    >
      <Input value={value} onChange={onChange} style={{ background: value }} />
    </Popover>
  );
}
